import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";

// ✅ Import Slices
import authReducer from "./slices/authSlice";
import allUserReducer from "./slices/allUserSlice";
import allUserRoleReducer from "./slices/allUserRoleSlice";
import allUserGroupReducer from "./slices/allUserGroupSlice";
import statesReducer from "./slices/statesSlice";
import countryReducer from "./slices/countrySlice";
import organizationMasterReducer from "./slices/organizationMasterSlice";
import entityMasterReducer from "./slices/entityMasterSlice";
import sponsorMasterReducer from "./slices/sponsorMasterSlice";
import familyOfficeMasterReducer from "./slices/familyOfficeMasterSlice";
import enumReducer from "./slices/enumSlice";
import entityTypeMasterReducer from "./slices/entityTypeMasterSlice";
import investmentMandateTypeReducer from "./slices/investmentMandateTypeSlice";
import assetTypeReducer from "./slices/assetTypeSlice";
import assetsReducer from "./slices/assetsSlice";
import investmentMasterReducer from "./slices/investmentMasterSlice";
import documentTypeReducer from './slices/documentTypeSlice';
import documentMasterReducer from './slices/documentMasterSlice';
import logsReducer from './slices/riskAssessmentLogsSlice';
import opportunityTypeReducer from './slices/opportunityTypeSlice';
import opportunityMasterReducer from './slices/opportunityMasterSlice';
import opportunityApplicationReducer from './slices/opportunityApplicationSlice';
import opportunityAllocationReducer from './slices/opportunityAllocationSlice';
import memberInterviewRecordReducer from './slices/memberInterviewRecordSlice';
import opportunityApplicationInterviewReducer from './slices/opportunityApplicationInterviewSlice';
import entityCapReducer from './slices/entityCapSlice';
import mentorshipMasterReducer from './slices/mentorshipMasterSlice';
import eventMasterReducer from './slices/eventMasterSlice';
import eventTypeReducer from './slices/eventTypeSlice';
import sovereignEventLedgerReducer from './slices/sovereignEventLedgerSlice';
import carbonSourceMasterReducer from './slices/carbonSourceMasterSlice';
import monitoringBatchReducer from './slices/monitoringBatchSlice';
import verificationRecordReducer from './slices/verificationRecordSlice';
import projectIntegrationReducer from './slices/projectIntegrationSlice';
import mintingTransactionReducer from './slices/mintingTransactionSlice';
import carbonInventoryReducer from './slices/carbonInventorySlice';
import carbonSaleTransactionReducer from './slices/carbonSaleTransactionSlice';
import retirementTransactionReducer from './slices/retirementTransactionSlice';
import familyOfficeAllocationReducer from './slices/familyOfficeAllocationSlice';
import speciesRegistryReducer from './slices/speciesRegistrySlice';
import methodLibraryReducer from './slices/methodLibrarySlice';
import riskMaterialityLogReducer from './slices/riskMaterialityLogSlice';
import emissionsLedgerReducer from './slices/emissionsLedgerSlice';
import auditDisclosureSnapshotReducer from './slices/auditDisclosureSnapshotSlice';

// ✅ Import Services
import { authService } from "./services/authService";
import { allUserService } from "./services/allUserService";
import { allUserRoleService } from "./services/userRoleService";
import { allUserGroupService } from "./services/userGroupService";
import { stateService } from "./services/stateService";
import { countryService } from "./services/countryService";
import { organizationMasterService } from "./services/organizationMasterService";
import dashboardReducer from './slices/dashbordSlice';
import { dashboardService } from './services/dashboardService';
import { entityMasterService } from './services/entityMasterService';
import { sponsorMasterService } from './services/sponsorMasterService';
import { familyOfficeMasterService } from './services/familyOfficeMasterService';
import { enumService } from './services/enumService';
import { entityTypeMasterService } from './services/entityTypeMasterService';
import { investmentMandateTypeService } from './services/investmentMandateTypeService';
import { assetTypeService } from './services/assetTypeService';
import { assetsService } from './services/assetsService';
import { investmentMasterService } from './services/investmentMasterService';
import { documentTypeService } from "./services/documentTypeService";
import { documentMasterService } from "./services/documentMasterService";
import { riskAssessmentLogService } from "./services/riskAssessmentLogService";
import { opportunityTypeService } from "./services/opportunityTypeService";
import { opportunityMasterService } from "./services/opportunityMasterService";
import { opportunityApplicationService } from "./services/opportunityApplicationService";
import { opportunityAllocationService } from "./services/opportunityAllocationService";
import { memberInterviewRecordService } from "./services/memberInterviewRecordService";
import { opportunityApplicationInterviewService } from "./services/opportunityApplicationInterviewService";
import { entityCapService } from "./services/entityCapService";
import { mentorshipMasterService } from "./services/mentorshipMasterService";
import { eventMasterService } from "./services/eventMasterService";
import { eventTypeService } from "./services/eventTypeService";
import { sovereignEventLedgerService } from "./services/sovereignEventLedgerService";
import { carbonSourceMasterService } from "./services/carbonSourceMasterService";
import { monitoringBatchService } from "./services/monitoringBatchService";
import { verificationRecordService } from "./services/verificationRecordService";
import { projectIntegrationService } from "./services/projectIntegrationService";
import { mintingTransactionService } from "./services/mintingTransactionService";
import { carbonInventoryService } from "./services/carbonInventoryService";
import { carbonSaleTransactionService } from "./services/carbonSaleTransactionService";
import { retirementTransactionService } from "./services/retirementTransactionService";
import { familyOfficeAllocationService } from "./services/familyOfficeAllocationService";
import { speciesRegistryService } from './services/speciesRegistryService';
import { methodLibraryService } from './services/methodLibraryService';
import { riskMaterialityLogService } from './services/riskMaterialityLogService';
import { emissionsLedgerService } from './services/emissionsLedgerService';
import { auditDisclosureSnapshotService } from './services/auditDisclosureSnapshotService';
import carbonProjectReducer from './slices/carbonProjectSlice';
import { carbonProjectService } from './services/carbonProjectService';
import emissionFactorReducer from './slices/emissionFactorSlice';
import { emissionFactorService } from './services/emissionFactorService';

export const store = configureStore({
  reducer: {
    // Slices
    auth: authReducer,
    allUser: allUserReducer,
    states: statesReducer,
    country: countryReducer,
    // city: cityReducer,
    allUserRole: allUserRoleReducer,
    allUserGroup: allUserGroupReducer,
    organizationMaster: organizationMasterReducer,
    entityCap: entityCapReducer,
    entityMaster: entityMasterReducer,
    sponsorMaster: sponsorMasterReducer,
    familyOfficeMaster: familyOfficeMasterReducer,
    enum: enumReducer,
    entityTypeMaster: entityTypeMasterReducer,
    investmentMandateType: investmentMandateTypeReducer,
    assetType: assetTypeReducer,
    assets: assetsReducer,
    documentType: documentTypeReducer,
    documentMaster: documentMasterReducer,
    logs: logsReducer,
    investmentMaster: investmentMasterReducer,
    dashboard: dashboardReducer,
    opportunityType: opportunityTypeReducer,
    opportunityMaster: opportunityMasterReducer,
    opportunityApplication: opportunityApplicationReducer,
    opportunityAllocation: opportunityAllocationReducer,
    memberInterviewRecord: memberInterviewRecordReducer,
    opportunityApplicationInterview: opportunityApplicationInterviewReducer,
    mentorshipMaster: mentorshipMasterReducer,
    eventMaster: eventMasterReducer,
    eventType: eventTypeReducer,
    sovereignEventLedger: sovereignEventLedgerReducer,
    carbonSourceMaster: carbonSourceMasterReducer,
    monitoringBatch: monitoringBatchReducer,
    verificationRecord: verificationRecordReducer,
    projectIntegration: projectIntegrationReducer,
    mintingTransaction: mintingTransactionReducer,
    carbonInventory: carbonInventoryReducer,
    carbonSaleTransaction: carbonSaleTransactionReducer,
    retirementTransaction: retirementTransactionReducer,
    familyOfficeAllocation: familyOfficeAllocationReducer,
    speciesRegistry: speciesRegistryReducer,
    methodLibrary: methodLibraryReducer,
    riskMaterialityLog: riskMaterialityLogReducer,
    emissionsLedger: emissionsLedgerReducer,
    auditDisclosureSnapshot: auditDisclosureSnapshotReducer,
    carbonProject: carbonProjectReducer,
    emissionFactor: emissionFactorReducer,

    [authService.reducerPath]: authService.reducer,
    [allUserService.reducerPath]: allUserService.reducer,
    [allUserRoleService.reducerPath]: allUserRoleService.reducer,
    [allUserGroupService.reducerPath]: allUserGroupService.reducer,
    [stateService.reducerPath]: stateService.reducer,
    [countryService.reducerPath]: countryService.reducer,
    [organizationMasterService.reducerPath]: organizationMasterService.reducer,
    [entityCapService.reducerPath]: entityCapService.reducer,
    [entityMasterService.reducerPath]: entityMasterService.reducer,
    [sponsorMasterService.reducerPath]: sponsorMasterService.reducer,
    [familyOfficeMasterService.reducerPath]: familyOfficeMasterService.reducer,
    [enumService.reducerPath]: enumService.reducer,
    [entityTypeMasterService.reducerPath]: entityTypeMasterService.reducer,
    [investmentMandateTypeService.reducerPath]: investmentMandateTypeService.reducer,
    [assetTypeService.reducerPath]: assetTypeService.reducer,
    [assetsService.reducerPath]: assetsService.reducer,
    [investmentMasterService.reducerPath]: investmentMasterService.reducer,
    [documentTypeService.reducerPath]: documentTypeService.reducer,
    [documentMasterService.reducerPath]: documentMasterService.reducer,
    [dashboardService.reducerPath]: dashboardService.reducer,
    [riskAssessmentLogService.reducerPath]: riskAssessmentLogService.reducer,
    [opportunityMasterService.reducerPath]: opportunityMasterService.reducer,
    [opportunityTypeService.reducerPath]: opportunityTypeService.reducer,
    [opportunityApplicationService.reducerPath]: opportunityApplicationService.reducer,
    [opportunityAllocationService.reducerPath]: opportunityAllocationService.reducer,
    [memberInterviewRecordService.reducerPath]: memberInterviewRecordService.reducer,

    [opportunityApplicationInterviewService.reducerPath]: opportunityApplicationInterviewService.reducer,
    [mentorshipMasterService.reducerPath]: mentorshipMasterService.reducer,
    [eventMasterService.reducerPath]: eventMasterService.reducer,
    [eventTypeService.reducerPath]: eventTypeService.reducer,
    [sovereignEventLedgerService.reducerPath]: sovereignEventLedgerService.reducer,
    [carbonSourceMasterService.reducerPath]: carbonSourceMasterService.reducer,
    [monitoringBatchService.reducerPath]: monitoringBatchService.reducer,
    [verificationRecordService.reducerPath]: verificationRecordService.reducer,
    [projectIntegrationService.reducerPath]: projectIntegrationService.reducer,
    [mintingTransactionService.reducerPath]: mintingTransactionService.reducer,
    [carbonInventoryService.reducerPath]: carbonInventoryService.reducer,
    [carbonSaleTransactionService.reducerPath]: carbonSaleTransactionService.reducer,
    [retirementTransactionService.reducerPath]: retirementTransactionService.reducer,
    [familyOfficeAllocationService.reducerPath]: familyOfficeAllocationService.reducer,
    [speciesRegistryService.reducerPath]: speciesRegistryService.reducer,
    [methodLibraryService.reducerPath]: methodLibraryService.reducer,
    [riskMaterialityLogService.reducerPath]: riskMaterialityLogService.reducer,
    [emissionsLedgerService.reducerPath]: emissionsLedgerService.reducer,
    [auditDisclosureSnapshotService.reducerPath]: auditDisclosureSnapshotService.reducer,
    [carbonProjectService.reducerPath]: carbonProjectService.reducer,
    [emissionFactorService.reducerPath]: emissionFactorService.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    })
      .concat(authService.middleware)
      .concat(allUserService.middleware)
      .concat(allUserRoleService.middleware)
      .concat(allUserGroupService.middleware)
      .concat(stateService.middleware)
      .concat(countryService.middleware)
      .concat(organizationMasterService.middleware)
      .concat(entityCapService.middleware)
      .concat(entityMasterService.middleware)
      .concat(sponsorMasterService.middleware)
      .concat(familyOfficeMasterService.middleware)
      .concat(enumService.middleware)
      .concat(entityTypeMasterService.middleware)
      .concat(investmentMandateTypeService.middleware)
      .concat(assetTypeService.middleware)
      .concat(assetsService.middleware)
      .concat(investmentMasterService.middleware)
      .concat(documentTypeService.middleware)
      .concat(documentMasterService.middleware)
      .concat(dashboardService.middleware)
      .concat(riskAssessmentLogService.middleware)
      .concat(opportunityMasterService.middleware)
      .concat(opportunityTypeService.middleware)
      .concat(opportunityApplicationService.middleware)
      .concat(opportunityAllocationService.middleware)
      .concat(memberInterviewRecordService.middleware)
      .concat(opportunityApplicationInterviewService.middleware)
      .concat(mentorshipMasterService.middleware)
      .concat(eventMasterService.middleware)
      .concat(eventTypeService.middleware)
      .concat(sovereignEventLedgerService.middleware)
      .concat(carbonSourceMasterService.middleware)
      .concat(monitoringBatchService.middleware)
      .concat(verificationRecordService.middleware)
      .concat(projectIntegrationService.middleware)
      .concat(mintingTransactionService.middleware)
      .concat(carbonInventoryService.middleware)
      .concat(carbonSaleTransactionService.middleware)
      .concat(retirementTransactionService.middleware)
      .concat(familyOfficeAllocationService.middleware)
      .concat(speciesRegistryService.middleware)
      .concat(methodLibraryService.middleware)
      .concat(riskMaterialityLogService.middleware)
      .concat(emissionsLedgerService.middleware)
      .concat(auditDisclosureSnapshotService.middleware)
      .concat(carbonProjectService.middleware)
      .concat(emissionFactorService.middleware)
  ,
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
